import React, { memo } from 'react'
import SpinningLoader from './index'
import Text from '../Text'
import * as Styled from './styled'
import { TColorKey } from 'types'
import { TTextType } from 'common-components/Text/types'

interface IProps {
  children: React.ReactNode
  loaderColor?: string
  loaderSize?: number
  wrapperSize?: number
  loadingText?: string
  loadingTextColor?: TColorKey
  strokeWidth?: number
  backdropFilter?: number
  loadingTextType?: TTextType
  scale?: number
}

const SpinningLoaderWrapper: React.FC<IProps> = ({
  children,
  loaderColor = '#ffffff',
  loaderSize = 18,
  wrapperSize = 30,
  loadingText,
  loadingTextColor = 'white',
  strokeWidth,
  backdropFilter = 15,
  loadingTextType = 'pageTitle',
  scale
}) => {
  return (
    <Styled.WrapperContainer>
      {children}
      <Styled.LoaderOverlay>
        <SpinningLoader
          loaderColor={loaderColor}
          size={loaderSize}
          wrapperSize={wrapperSize}
          strokeWidth={strokeWidth}
        />
        {loadingText && (
          <Styled.FixedSizeTextContainer $scale={scale}>
            <Text
              type={loadingTextType}
              align="center"
              color={loadingTextColor}
            >
              {loadingText}
            </Text>
          </Styled.FixedSizeTextContainer>
        )}
      </Styled.LoaderOverlay>
      <Styled.LoaderTransparentOverlay $backdropFilter={backdropFilter} />
    </Styled.WrapperContainer>
  )
}

export default memo(SpinningLoaderWrapper)
